<template>
	<div class="d-flex justify-end pa-2">
		<ao-btn color="primary"
			@click="$emit('select-date')">Выбрать</ao-btn>
	</div>
</template>

<script>
export default {
    name: 'ActionRow',

    emits: ['select-date']
}
</script>
